import { AdvisorUIConfiguration } from "@zoovu/runner-browser-api";

import sprite from "@/assets/Trek-Bikes-Sprite.svg";

export default {
  sprite: ({ webDesignContextPath }: AdvisorUIConfiguration) =>
    `url("${webDesignContextPath}${sprite}")`,
  colors: {
    darkBlack: "#000",
    black: "#1a1a1a",
    white: "#fff",
    gray: "#e6e6e6",
    gray2: "#f6f6f6",
    gray3: "#cbcbcb",
    gray4: "#808080",
    gray5: "#4d4d4d",
    blue: "#4D90FE",
    blue2: "#0087ce"
  },
  fontFamily: {
    robotoRegular: "Roboto-Regular",
    robotoMedium: "Roboto-Medium",
    avalonBold: "Avalon-Bold"
  },
  fontSize: {
    xxs: "12px",
    xs: "14px",
    sm: "16px",
    md: "18px",
    lg: "24px",
    xl: "34px"
  },
  breakpoints: {
    $xxs: "max-width: 360px",
    $sxs: "max-width: 650px",
    $xs: "max-width: 767px",
    $sm: "max-width: 920px",
    $tablet: "max-width: 1024px",
    $mdMax: "max-width: 1120px",
    $md: "min-width: 1120px",
    $lg: "min-width: 1400px"
  },
  layout: {
    maxContainerWidth: "1256px"
  }
};
